import { ErrorOutline } from "@mui/icons-material";
import HowToRegIcon from '@mui/icons-material/HowToReg';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import { Divider, Tooltip } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import packagejson from "../../../package.json";
import { logout } from "../../redux/actions/auth";
import CloseSessionDialog from "../commons/dialog/CloseSessionDialog";
import { StyledUserActions } from "../styled/Layout";
import ChangePasswordDialogContainer from "./ChangePassword/ChangePasswordDialogContainer";

const UserActionsContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const authData = useSelector((state) => state.auth.data);
  const [anchorMenu, setAnchorMenu] = useState();
  const [openChangePassword, setOpenChangePassword] = useState();
  const [openLogout, setOpenLogout] = useState();
  const handleLogout = () => {
    dispatch(logout());
    location.pathname = "/";
  };
  return (
    <>

      <Tooltip title="Cuenta" aria-label="cuenta">
        <StyledUserActions.IconButton
          onClick={(event) => setAnchorMenu(event.currentTarget)}
        >
          <PersonIcon
            aria-haspopup="true"
            color="inherit"
          />
        </StyledUserActions.IconButton>
      </Tooltip>
      <StyledUserActions.Menu
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMenu(null)}
        getContentAnchorEl={null}
      >
        <StyledUserActions.MenuList disablePadding>
          <StyledUserActions.InfoMenuItem disableRipple>
            <StyledUserActions.MenuItemIcon component={ErrorOutline}/>
            Versión {packagejson.version}
          </StyledUserActions.InfoMenuItem>
          <Divider />
          {
            authData.tipoUsuario === "PRODUCTOR" && (
              <>
                <StyledUserActions.InfoMenuItem disableRipple>
                  <StyledUserActions.MenuItemIcon component={HowToRegIcon}/>
                  <Tooltip title={`Empleador Actual: ${authData?.nombreEmpleador}`}>
                    <StyledUserActions.TextEmpleadorActual>
                      {authData?.nombreEmpleador}
                    </StyledUserActions.TextEmpleadorActual>
                  </Tooltip>
                </StyledUserActions.InfoMenuItem>

                <StyledUserActions.MenuItem onClick={() => navigate("/empleador")}>
                  <StyledUserActions.MenuItemIcon component={SwitchAccountIcon}  />
                  Cambiar Empleador
                </StyledUserActions.MenuItem>

                <Divider />
              </>
            )
          }
          <StyledUserActions.MenuItem onClick={() => setOpenChangePassword(true)}>
            <StyledUserActions.MenuItemIcon component={LockOutlinedIcon}/>
            Cambiar contraseña
          </StyledUserActions.MenuItem>
          <StyledUserActions.MenuItem onClick={() => setOpenLogout(true)}>
            <StyledUserActions.MenuItemIcon component={LogoutIcon}/>
            Cerrar Sesión
          </StyledUserActions.MenuItem>
        </StyledUserActions.MenuList>
      </StyledUserActions.Menu>
      <ChangePasswordDialogContainer
        open={openChangePassword}
        handleClose={() => setOpenChangePassword(false)}
      />
      <CloseSessionDialog
        open={openLogout}
        handleClose={() => setOpenLogout(false)}
        handleConfirm={handleLogout}
      />
    </>
  )

}

export default UserActionsContainer;

